export default __webpack_public_path__ + "static/media/Bengali_ef_1.929ac303.mp3";